export default __webpack_public_path__ + "static/media/invoice.cb09a573.svg";